"use strict";

(function (Drupal) {
  Drupal.behaviors.media_grid = {
    attach: function attach(context, settings) {
      var gridContainer = context.querySelectorAll('.layout--twocol--media-grid');
      if (!gridContainer || gridContainer.length === 0) return;

      /* Initialize the grid container and grab the columns for transformation */
      var initGrid = function initGrid() {
        gridContainer.forEach(function (container) {
          var columns = container.querySelectorAll('.col');
          columns.forEach(function (el) {
            // Get the column wrapper.
            var wrapper = el.querySelector('.col__content');

            // Count the child elements in the column.
            var innerLength = wrapper.childElementCount;

            // Add the appropriate class based on number of children.
            switch (innerLength) {
              case 1:
                el.classList.add('is-portrait');
                break;
              case 2:
                el.classList.add('is-landscape');
                break;
            }
          });
        });
      };
      initGrid();
    }
  };
})(Drupal);